export default {"src":"/_next/static/media/briefcase.50b14237.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};